import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames'
import SellReport from './SellReport2'
// import TradingReport from './TradingReport'
import SellReportPromotion from './SellReportPromotion'
import TradingReport from './TradingReport'

class ReportTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      activeTab: '1',
    }

    this.toggle = this.toggle.bind(this);

  }

  componentWillMount () {
    console.log('1. componentWillMount')
    this.setState({
      user: JSON.parse(this.props.user),
    });

  }

  componentDidMount() {
    console.log('2. componentWillMount')
    // {this.state.user.user}
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  // render() {
  //   return(
  //     <div className="col-md-12">
  //       xxx
  //     <div/>
  //   )
  // }

  render () {
    return(
      <div className="col-md-12">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '1' })}
              onClick={() => { this.toggle('1'); }}
            >
              <i className="icon-options-vertical"/> รายงานการขาย
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' })}
              onClick={() => { this.toggle('2'); }}
            >
              <i className="icon-paper-clip"/> รายงานการซื้อขาย
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '3' })}
              onClick={() => { this.toggle('3'); }}
            >
              <i className="icon-paper-clip"/> รายงานการขายตามโปร
            </NavLink>
          </NavItem>

        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <SellReport />
          </TabPane>

          <TabPane tabId="2" >
            <TradingReport />
          </TabPane>

          <TabPane tabId="3" >
            <SellReportPromotion />
          </TabPane>

        </TabContent>

      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  type: state.auth.type,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(ReportTab);

